// Constraint is that for a CIF_NORO and a type, the serial number is unique
// the serial number is: prefix + currentNo + sufix
// the serial number is incremented by 1 for each new document, no gaps allowed
// at the activation we can se any currentNo, but the next one will be the one we set + 1
// we can have many active serial number for a CIF_NORO and a type but we set this to 1 in this version

// export type TFiscalBook = {
//   ID: number; // AUTOINCREMENT
//   CIF_NORO: string; // 1234567890 - FISCAL CODE
//   type: 'INVOICE' | 'RECEIPT';
//   alias: string; // A NAME FOR THE Sequence
//   amaId: number | null; // THE USER IN CHARGE
//   activeFrom: string; // 01.01.2021
//   inactiveFrom: string | null; // 01.01.2024
//   prefix: string;
//   currentNo: number; // <<< <<<< <<<< Secvential per activeFrom CIF_NORO and type
//   sufix: string;
//   notes: string | null;
//   // the serial number is: prefix + currentNo + sufix //
// };

// so we need to check uniquness, sequence and ensure that one instance is active at a time
import { TBlueTable } from "@app/types/insider";

import { epBuilderAnyIssuerNoSlices } from "../routines/mapperfn-pathbuilder";

export type TFiscalBook = {
  FCT_FF: number;
  PREFIX: string;
  NUMARCIFRE: number;
  SUFIX: string;
  NUMAR: number;
  EMITENT: string;
  CIF_EMITENT: string;
  CHITANTA: number;
  CHELTUIELI: number;
  ESTE_CURENT: number;
  ALIAS: string;
  EXPLICATII: string;
  ALIAS_BIFAT: number;
  ACTIV_DELA: string;
  INACTIV_DELA: string;
  AMA_ID: number;
  NOTA: string;
  ERROR_MESSAGE: string;
  EXEMPLU?: string;
};

export type TFiscalBookToDb = {
  FCT_FF: number; // This is the key of everything
  PREFIX: string;
  NUMARCIFRE: number;
  SUFIX: string;
  NUMAR: number;
  EMITENT: string;
  CIF_EMITENT: string;
  CHITANTA: number;
  CHELTUIELI: number;
  ESTE_CURENT: number;
  ALIAS: string;
  EXPLICATII: string;
  ALIAS_BIFAT: number;
  ACTIV_DELA: string;
  INACTIV_DELA: string;
  AMA_ID: number;
  NOTA: string;
};

export const fiscalBooks: TBlueTable<TFiscalBook> = {
  name: "fiscalBooks",
  empty: {} as TFiscalBook,
  initialState: {},
  primaryKey: "FCT_FF",
  apiUrl: "/select/fiscalBooks",
  pkeyUrl: null,
  urlPathBuilder: epBuilderAnyIssuerNoSlices,
  mapWrite: (data) => data,
  mapRead: (data) => data,
  starfx: true,
  idb: true,
  starfx_index: "FCT_FF",
  idb_indexes: [],
  bootPriority: 2,
  onmru: "ifempty",
  oncsdb: "full",
  label: "Registre fiscale",
  appContext: ["CtxPersonalKarma", "CtxJurnalCorporate"],
  /* 
  
  some random thoughts:

  when bootup - query if missing;  >> once per session fastest.. first thing.

  when building client side db - fetch to cs.db aka sync.  >> once per session normal priority. after bootup is settled.

  polling: rarely or no polling. when building the db, we can check if the data is the same.>> on timer.

  swr true at all the db objects.
  no need for sharding. >> no sharding

  */
};
